export default __webpack_public_path__ + "static/media/moments-social.691be392.png";